import React from 'react'

import styles from './FormRowSeparator.module.scss'

export default () => <div className={styles['row-separator']} />
